module.exports = __webpack_public_path__ + "img/commandpost_parked.7dadee5b.svg";